module.exports = __webpack_public_path__ + "img/registerimage3.87f5d0b2.png";